import * as React from "react";

import { CacheDataForTheSuccessPage } from "./cache-data-for-the-success-page";
import { SuccessPresenter } from "./success-presenter";

export const SuccessProvider: React.FunctionComponent = (props) => {
  return (
    <React.Fragment>
      <CacheDataForTheSuccessPage>
        <SuccessPresenter>{props.children || []}</SuccessPresenter>
      </CacheDataForTheSuccessPage>
    </React.Fragment>
  );
};
